import React from 'react';
import PropTypes from 'prop-types';

const ProffesionIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 14.664">
        <path d="M15.534 3.388a1.731 1.731 0 00-1.27-.556h-2.679V1.72A1.722 1.722 0 009.865 0h-3.73a1.722 1.722 0 00-1.72 1.72v1.112H1.737a1.731 1.731 0 00-1.27.556A1.728 1.728 0 000 4.569v8.358a1.739 1.739 0 001.737 1.737h12.526A1.739 1.739 0 0016 12.927V4.569a1.729 1.729 0 00-.462-1.175zM5.66 1.72a.476.476 0 01.475-.477h3.73a.476.476 0 01.476.476v1.112H5.66zm8.6 2.356h.015a6.769 6.769 0 01-4.9 2.712 1.853 1.853 0 00-2.751 0 6.768 6.768 0 01-4.9-2.712h12.539zM8 7.423a.618.618 0 11-.618.618A.618.618 0 018 7.423zm6.263 6H1.737a.493.493 0 01-.492-.492V5.52a8.413 8.413 0 004.9 2.455v.065a1.862 1.862 0 103.724 0v-.065a8.412 8.412 0 004.9-2.455v7.407a.493.493 0 01-.506.493z" fill={fill} />
    </svg>
);

ProffesionIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

ProffesionIcon.defaultProps = {
    width: '16',
    height: '14.664',
    fill: '#4b254e'
};

export default ProffesionIcon;
